export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const UNPUBLISH_PRODUCT = 'UNPUBLISH_PRODUCT'
export const SET_VACATION = 'SET_VACATION'
export const SET_PRODUCT_CATEGORIES = 'SET_PRODUCT_CATEGORIES'
export const SET_PRODUCT_IDS = 'SET_PRODUCT_IDS'
export const UPDATE_PRODUCT_DISCOUNT = 'UPDATE_PRODUCT_DISCOUNT'

export const PRODUCT_STATE_KEY = 'products'
